import { useQuery } from '@tanstack/react-query';
import { fetchPassbookQuotas, channelQuotaKey } from '../api/billing';
import { seedQuotas, type PassbookQuotas } from './ledger';

export function useChannelQuotas(passbookId?: string) {
  const query = useQuery({
    queryKey: channelQuotaKey(passbookId ?? 'none'),
    enabled: Boolean(passbookId),
    queryFn: () => fetchPassbookQuotas(passbookId!),
    retry: false,
    staleTime: 15_000,
  });

  const quotas: PassbookQuotas | null = query.data ?? (passbookId ? seedQuotas(passbookId) : null);

  return {
    ...query,
    quotas,
    live: Boolean(query.data),
  };
}
